import { GenexSISModel } from "@/models/sis/GenexSISModel";
import { normalize } from "@/utils/data";

export default class CheckpointTemplate extends GenexSISModel {
  static entity = "checkpoint-templates";

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(null),
      checkpoints: this.attr([]),
    };
  }

  static FetchAll({ page = 1, limit = 15 }, query = {}, relationships = []) {
    return this.GenexAxiosGet("CheckpointTemplate.FetchAll", "/checkpoint-templates", {
      params: {
        page: page,
        limit: limit,
        ...(Object.keys(query).length > 0 ? query : {}),
        with: relationships,
      },
      dataTransformer: ({ data: { data } }) => {
        return normalize(data);
      },
    });
  }

  static Store(template) {
    return this.GenexAxiosPost("CheckpointTemplate.Store", `/checkpoint-templates`, template, {
      dataTransformer: ({ data: { data } }) => {
        return normalize(data);
      },
    });
  }

  static Update(template) {
    return this.GenexAxiosPatch("CheckpointTemplate.Update", `/checkpoint-templates/${template.id}`, template, {
      dataTransformer: ({ data: { data } }) => {
        return normalize(data);
      },
    });
  }

  static Delete(id) {
    return this.GenexAxiosDelete("CheckpointTemplate.Delete", `/checkpoint-templates/${id}`, {
      delete: id,
    });
  }
}
